import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router v6's createBrowserRouter does not restore scroll on its own.
// The app's scroll container is <main> (overflow-y: auto in App.scss), so a
// plain window.scrollTo(0, 0) is not enough — we reset both.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.querySelector("main");
    if (main) {
      main.scrollTop = 0;
    }
    if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
